'use strict';
import BasePreprocessor from './BasePreprocessor';

export default class SearchPreprocessor extends BasePreprocessor {
	constructor() {
		super();

		var keyword = '';

		Object.defineProperty(this, 'keyword', {
			get: function () {
				return keyword;
			},
			set: function (newKeyword) {
				if (keyword !== newKeyword) {
					keyword = newKeyword;

					if (this.executor.preprocessors.pagingPreprocessor) {
						this.executor.preprocessors.pagingPreprocessor.page = 0;
					}
					this.changed();
				}
			},
		});
	}

	init(executor) {
		this.executor = executor;
	}
}
